export default __webpack_public_path__ + "static/testimonial-bg-7e37415884312b5db0ebb933645da431.svg";